import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import { withRouterLegacy } from 'core/routerUtils';
import { withTranslation } from 'react-i18next';
import * as rostersActions from 'features/rosters/duck';
import * as tcEventActions from 'features/tc-event-dashboard/duck';
import * as staticActions from 'shared/ducks/staticDuck';
import { RostersDownload, RostersPanel } from 'features/rosters';
import moment from 'moment';
import {
  Select,
  Spinner,
  SimpleModal,
  EventDashboardDetails,
  ModalInfo,
  AlertMessage,
  MarkAsDeniedModal,
} from 'shared/components';
import { EXAM_CATEGORIES, ONLINE_PROVIDERS } from 'shared/constants';
import { getFirstElement } from 'shared/helpers';
import { getPersonnelRoles } from 'shared/selectors';
import { find, isEmpty, omitBy } from 'lodash';
import { DEFAULT_PARAMS, pageSizeOptions } from '../helpers';
import { orderLocationExamineeCount, mapLocEvDateFilters, mapEvDateFilters } from '../selectors';
import Parser from 'html-react-parser';
import AvailableRoomsModal from './AvailableRoomsModal';
import './RostersDashboard.scss';
import AuthorizationTicketsModal from './AuthorizationTicketsModal';
import RostersService from '../RostersService';

import BlueArrowIcon from 'assets/svgs/blueDownArrow.svg';

const locationEventSelect = (locations) => {
  return locations.map((location) => ({
    value: location.locationEvent.id,
    label: `${location.name}${location.area && location.area.length > 0 && `, ${location.area}`}`,
  }));
};

const mapCurrentList = (currentList, selectedList) => {
  return currentList.map((examinee) => ({
    ...examinee,
    checked: selectedList.some((el) => el.id === examinee.id),
  }));
};

class RostersDashboard extends Component {
  constructor(props) {
    super(props);
    this.child = React.createRef();

    this.state = {
      modalAvailableRoomsOpen: false,
      selectedLocation: {},
      warningLocationOpen: false,
      listOfSelectedExaminees: [],
      currentList: [],
      filterParams: {},
      assignModalOpen: false,
      defaultLimit: DEFAULT_PARAMS.limit,
      showFilters: true,
      temporarySearchValue: '',
      hasSearchValue: false,
      authorizationModalOpen: false,
      markAsAbsentModalIsOpen: false,
      markAsDeniedModalIsOpen: false,
      errorMessage: '',
      successDeniedMessage: '',
      successAbsentMessage: '',
      skip: 0,
    };

    this.fetchProps = this.fetchProps.bind(this);
    this.fetchExaminees = this.fetchExaminees.bind(this);
    this.toggleAvailableRoomsModal = this.toggleAvailableRoomsModal.bind(this);
    this.onChangeSelection = this.onChangeSelection.bind(this);
    this.onUpdateFilters = this.onUpdateFilters.bind(this);
    this.onChangePage = this.onChangePage.bind(this);
    this.clearFilters = this.clearFilters.bind(this);
    this.onConfirmSelectionWarning = this.onConfirmSelectionWarning.bind(this);
    this.closeSelectionModal = this.closeSelectionModal.bind(this);
    this.onUpdateSelectedExaminees = this.onUpdateSelectedExaminees.bind(this);
    this.onDeselectAllExaminees = this.onDeselectAllExaminees.bind(this);
    this.toggleFilters = this.toggleFilters.bind(this);
    this.setTemporarySearchValue = this.setTemporarySearchValue.bind(this);
    this.setHasSearchValue = this.setHasSearchValue.bind(this);
    this.toggleAuthorizationModal = this.toggleAuthorizationModal.bind(this);
  }

  componentDidMount() {
    const { actions, match } = this.props;

    actions.getServerDateTime();
    actions.clearLocationEventExamineesAction();
    actions.getTcEvent(match.params.eventId).then(() => {
      actions.getTestCenterCycle(match.params.eventId);
      actions.getRooms(match.params.eventId);
      if (!isEmpty(this.props.tcEvent)) {
        actions.getEvRescheduleDates(this.props.tcEvent.id);
        actions.getRegTypes(this.props.tcEvent.testingEvent.adminId.cycleId.id);
      }
      this.fetchProps();
    });
  }

  componentDidUpdate(prevProps) {
    const { locationEventId } = this.props.match.params;
    const prevLocationEventId = prevProps.match.params.locationEventId;
    const { selectedLocation } = this.state;

    if (
      !isEmpty(selectedLocation) &&
      selectedLocation.locationEvent.id !== +locationEventId &&
      locationEventId !== prevLocationEventId
    ) {
      this.fetchProps(+locationEventId);
      this.setState({
        selectedLocation: find(
          this.props.locations,
          (location) => location.locationEvent.id === +locationEventId
        ),
      });
    }

    if (!prevProps.locations.length && this.props.locations.length) {
      this.setState({
        selectedLocation: find(
          this.props.locations,
          (location) => location.locationEvent.id === +locationEventId
        ),
      });
    }
  }

  fetchProps(locEvId) {
    const { locationEventId } = this.props.match.params;
    const { actions, tcEvent } = this.props;
    let categoryParam;

    if (tcEvent.rescheduleDate) {
      actions.getLocEvRescheduleDates(tcEvent.id, locEvId || locationEventId);
    }
    actions.getLocationEventRoomRosters(locEvId || locationEventId);
    actions.getLocationEventExamineeCount(locEvId || locationEventId).then(() => {
      if (this.props.locationExamineeCount.length > 0) {
        categoryParam = getFirstElement(this.props.locationExamineeCount).type;

        this.setState({
          filterParams: {
            ...DEFAULT_PARAMS,
            category: categoryParam,
          },
          defaultLimit: DEFAULT_PARAMS.limit,
          listOfSelectedExaminees: [],
        });
        this.fetchExaminees(
          { ...DEFAULT_PARAMS, category: categoryParam },
          locEvId || locationEventId
        );
      } else {
        console.warn('No examinee counts available.');
      }
    });

    if (this.child.current) {
      this.child.current.clearFilters(true);
    }
  }

  fetchExaminees(params, locEvId) {
    const { actions } = this.props;

    this.setState({
      filterParams: params,
      currentList: [],
    });
    actions.clearLocationEventExamineesAction();
    actions.getLocationEventExaminees(locEvId, params, {});
  }

  toggleAvailableRoomsModal() {
    const { locationEventId } = this.props.match.params;

    if (!this.state.modalAvailableRoomsOpen) {
      this.props.actions.getLocationEventRoomRosters(locationEventId);
    }

    this.setState((prevState) => ({
      modalAvailableRoomsOpen: !prevState.modalAvailableRoomsOpen,
    }));
  }

  onChangeSelection(e) {
    const { value } = e.target;
    const { listOfSelectedExaminees } = this.state;

    if (listOfSelectedExaminees.length) {
      this.setState({
        warningLocationOpen: true,
        selectedLocation: find(
          this.props.locations,
          (location) => location.locationEvent.id === +value
        ),
      });
      return;
    }

    this.setState({
      selectedLocation: find(
        this.props.locations,
        (location) => location.locationEvent.id === +value
      ),
    });
    this.props.history.replace(`/test-event/${this.props.match.params.eventId}/rosters/${value}`);
  }

  onUpdateFilters(filterParams) {
    const { locationEventId } = this.props.match.params;
    const params = {
      ...omitBy(filterParams || { ...this.state.filterParams }, (el) => !el),
    };

    if (this.state.filterParams.category !== params.category) {
      this.onDeselectAllExaminees();
    }

    this.fetchExaminees(
      { ...params, skip: DEFAULT_PARAMS.skip, limit: this.state.defaultLimit },
      locationEventId
    );
  }

  onChangePage(startIdx, endIdx, newLimit) {
    const { locationEventId } = this.props.match.params;
    const { actions, locationEventExaminees } = this.props;
    const { listOfSelectedExaminees, filterParams } = this.state;
    if (!locationEventExaminees[startIdx] || newLimit) {
      this.setState({
        currentList: [],
      });
      actions
        .getLocationEventExaminees(
          locationEventId,
          {
            ...filterParams,
            limit: newLimit || this.state.defaultLimit,
            skip: startIdx,
          },
          { startIdx, endIdx, newLimit }
        )
        .then(() => {
          this.setState((prevState) => ({
            currentList: mapCurrentList(
              this.props.locationEventExaminees.concat([]).slice(startIdx, endIdx + 1),
              listOfSelectedExaminees
            ),
            defaultLimit: newLimit || prevState.defaultLimit,
            filterParams: {
              ...prevState.filterParams,
              limit: newLimit || prevState.defaultLimit,
            },
            skip: startIdx,
          }));
        });
      return;
    }

    this.setState({
      currentList: mapCurrentList(
        this.props.locationEventExaminees.concat([]).slice(startIdx, endIdx + 1),
        listOfSelectedExaminees
      ),
      skip: startIdx,
    });
  }

  clearFilters() {
    const { locationEventId } = this.props.match.params;
    const { filterParams, defaultLimit } = this.state;
    let clearedParams = {
      limit: defaultLimit,
      skip: DEFAULT_PARAMS.skip,
      category: filterParams.category,
      denied: 0,
      absent: 0,
    };

    this.child.current.clearFilters(false);
    this.fetchExaminees(clearedParams, locationEventId);
  }

  onConfirmSelectionWarning() {
    const { selectedLocation } = this.state;
    this.setState(() => ({
      warningLocationOpen: false,
    }));

    this.fetchProps(selectedLocation.locationEvent.id);
    this.props.history.replace(
      `/test-event/${this.props.match.params.eventId}/rosters/${selectedLocation.locationEvent.id}`
    );
  }

  closeSelectionModal() {
    const { locationEventId } = this.props.match.params;

    this.setState(() => ({
      warningLocationOpen: false,
      selectedLocation: find(
        this.props.locations,
        (location) => location.locationEvent.id === +locationEventId
      ),
    }));
  }

  onUpdateSelectedExaminees(listOfSelectedExaminees) {
    this.setState({
      listOfSelectedExaminees,
      currentList: mapCurrentList(this.state.currentList, listOfSelectedExaminees),
    });
  }

  onDeselectAllExaminees() {
    this.onUpdateSelectedExaminees([]);
  }

  toggleFilters() {
    this.setState((prevState) => ({
      showFilters: !prevState.showFilters,
    }));
  }

  setTemporarySearchValue(temporarySearchValue) {
    this.setState({
      temporarySearchValue: temporarySearchValue,
    });
  }

  setHasSearchValue(hasSearchValue) {
    this.setState({
      hasSearchValue: hasSearchValue,
    });
  }

  toggleAuthorizationModal() {
    this.setState((prevState) => ({
      authorizationModalOpen: !prevState.authorizationModalOpen,
    }));
  }

  unAssignStudent = async (absent, deniedReason, deniedReasonDetails) => {
    const { locationEventId } = this.props.match.params;
    const { actions } = this.props;

    let studentsToDeassign = [];
    this.state.listOfSelectedExaminees.map((item) => studentsToDeassign.push(item.id));
    const data = {
      absent: absent,
      deniedReason: deniedReason || null,
      deniedReasonDetails: deniedReasonDetails || null,
      regIds: studentsToDeassign,
    };
    try {
      const unassignResult = await RostersService.unassignExaminees(locationEventId, data);
      const selectedNumber = typeof unassignResult === 'number' ? unassignResult : 0;
      this.setState({
        listOfSelectedExaminees: [],
      });
      this.onUpdateSelectedExaminees([]);
      this.setState({
        markAsDeniedModalIsOpen: false,
        markAsAbsentModalIsOpen: false,
      });
      await actions.getLocationEventExaminees(
        locationEventId,
        { ...this.state.filterParams, skip: this.state.skip },
        {
          startIdx: this.state.skip,
          endIdx: this.state.skip + this.state.filterParams.limit,
        }
      );
      const newList = mapCurrentList(
        this.props.locationEventExaminees
          .concat([])
          .slice(this.state.skip, this.state.skip + this.state.filterParams.limit),
        this.state.listOfSelectedExaminees
      );
      this.setState({
        currentList: newList,
      });
      if (absent) {
        this.setState({
          successAbsentMessage: Parser(
            this.props.t('roomRoster.successAbsentMessage', {
              number: selectedNumber,
            })
          ),
        });
      } else if (deniedReason) {
        this.setState({
          successDeniedMessage: Parser(
            this.props.t('roomRoster.successDeniedMessage', {
              number: selectedNumber,
            })
          ),
        });
      }
    } catch (err) {
      this.setState({
        markAsAbsentModalIsOpen: false,
        markAsDeniedModalIsOpen: false,
        errorMessage: this.props.t('errors.somethingWentWrong'),
      });
    }
  };

  onSubmitHandle = (e, absent) => {
    this.unAssignStudent(absent, null, null);
  };

  openAbsentModal = () => {
    this.setState({
      markAsAbsentModalIsOpen: true,
    });
  };
  closeAbsentModal = () => {
    this.setState({
      markAsAbsentModalIsOpen: false,
    });
  };

  openDeniedModal = () => {
    this.setState({
      markAsDeniedModalIsOpen: true,
    });
  };
  closeDeniedModal = () => {
    this.setState({
      markAsDeniedModalIsOpen: false,
    });
  };

  render() {
    const {
      locationExamineeCount,
      locationEventRoomRosters,
      locations,
      testCenterCycle,
      tcEvent,
      examineesTotalCount,
      loadingExaminees,
      serverDateTime,
      history,
      match,
      loadingRoomsRosters,
      locEvDateFilters,
      rescheduleDates,
      evDateFilters,
      regTypes,
      absentCount,
      deniedCount,
    } = this.props;

    const {
      modalAvailableRoomsOpen,
      selectedLocation,
      filterParams,
      warningLocationOpen,
      listOfSelectedExaminees,
      currentList,
      defaultLimit,
      showFilters,
    } = this.state;

    const hasOnlineAssigned = locationExamineeCount.find((item) => item.type === 'O') || {};
    const hasNationalOnlineAssigned =
      locationExamineeCount.find((item) => item.type.includes('ONLINE')) || {};

    const isPsiEvent =
      !isEmpty(tcEvent) &&
      tcEvent.testingEvent?.adminId &&
      tcEvent.testingEvent.adminId.onlineProvider === ONLINE_PROVIDERS.psi;
    const hasNowManagedFlag =
      this.props.testCenterCycle.testCenterProgram?.testCenter.nowManagedFlag;

    const showNationalAuthorizationButton =
      isPsiEvent && !isEmpty(hasNationalOnlineAssigned) && hasNationalOnlineAssigned.regsCount > 0;
    const showDistrictAndStateAuthorizationButton =
      hasNowManagedFlag && !isEmpty(hasOnlineAssigned) && hasOnlineAssigned.regsCount > 0;

    if (
      isEmpty(tcEvent) ||
      tcEvent.loading ||
      isEmpty(testCenterCycle) ||
      testCenterCycle.loading ||
      isEmpty(selectedLocation)
    ) {
      return <Spinner />;
    }

    return (
      <div className="rosters-dashboard">
        <div className="container">
          <div className="header-section">
            <div className="column left">
              <div className="title-container">
                <h4>
                  {this.props.t('rosters.title')}
                  {!!tcEvent.rescheduleDate && (
                    <span className="reschedule-label ml-4">
                      {this.props.t('common.labels.rescheduled')}
                    </span>
                  )}
                </h4>
              </div>
              <EventDashboardDetails
                date={tcEvent.testingEvent.name}
                name={testCenterCycle.testCenterProgram.testCenter?.name}>
                {locations.length > 1 ? (
                  <Select
                    className="location-event-select"
                    options={locationEventSelect(locations)}
                    value={selectedLocation.locationEvent.id}
                    placeholder=""
                    name="eventLocation"
                    onChange={this.onChangeSelection}
                    icon={<BlueArrowIcon />}
                  />
                ) : (
                  <div>
                    {selectedLocation.name}
                    {selectedLocation.area &&
                      selectedLocation.area.length > 0 &&
                      `, ${selectedLocation.area}`}
                  </div>
                )}
              </EventDashboardDetails>
              <div className="dark-gray updated text-start">
                {this.props.t('rosters.updated')}{' '}
                {tcEvent.lastRegSyncDate && moment(tcEvent.lastRegSyncDate).format('MM.DD.YYYY')}
              </div>
            </div>

            <div className="column right">
              <div>
                <button
                  className="fw-bold btn-link pl-0 mb-3"
                  onClick={this.toggleAvailableRoomsModal}>
                  {this.props.t('rosters.availableRoomsModal.linkLabel', {
                    count: locationEventRoomRosters.length,
                  })}
                </button>
              </div>
              <div>
                {(showDistrictAndStateAuthorizationButton || showNationalAuthorizationButton) && (
                  <button className="btn btn-outline" onClick={this.toggleAuthorizationModal}>
                    {this.props.t('onlineTesting.authorizationTickets.downloadRoster')}
                  </button>
                )}
                <RostersDownload
                  tcEvent={tcEvent}
                  eventId={match.params.eventId}
                  serverDateTime={serverDateTime}
                  dateFilters={evDateFilters}
                />
              </div>
            </div>
          </div>
          <RostersPanel
            ref={this.child}
            examineesSelectedFlag={!!listOfSelectedExaminees.length}
            filterParams={filterParams}
            locationExamineeCount={locationExamineeCount}
            onUpdateFilters={this.onUpdateFilters}
            onDeselectAllExaminees={this.onDeselectAllExaminees}
            dateFilters={locEvDateFilters}
            hasRescheduleDate={!!tcEvent.rescheduleDate}
            showFilters={showFilters}
            toggleFilters={this.toggleFilters}
            setTemporarySearchValue={this.setTemporarySearchValue}
            temporarySearchValue={this.state.temporarySearchValue}
            setHasSearchValue={this.setHasSearchValue}
            hasSearchValue={this.state.hasSearchValue}
            itemsTotalCount={examineesTotalCount}
            onChangePage={this.onChangePage}
            paginationDataParams={filterParams}
            pageSize={defaultLimit}
            pageSizeOptions={pageSizeOptions}
            ofLabel={this.props.t('rosters.examineesOfLabel')}
            showSelectPage
            onReloadExaminees={this.onUpdateFilters}
            selectedLocation={selectedLocation}
            listOfSelectedExaminees={listOfSelectedExaminees}
            goBack={history.goBack}
            loadingExaminees={loadingExaminees}
            locationEventExaminees={currentList}
            singleRoom={filterParams.category === EXAM_CATEGORIES.single}
            onUpdateSelectedExaminees={this.onUpdateSelectedExaminees}
            dateAvailable={tcEvent.rescheduleDate && !!rescheduleDates.length}
            clearFilters={this.clearFilters}
            regTypes={regTypes}
            hasNowManagedFlag={hasNowManagedFlag}
            openAbsentModal={this.openAbsentModal}
            openDeniedModal={this.openDeniedModal}
            absentCount={absentCount}
            deniedCount={deniedCount}
            program={testCenterCycle.testCenterProgram.program}
            cycle={testCenterCycle.cycle}
          />
        </div>
        {!listOfSelectedExaminees.length && (
          <button className="btn btn-outline roster-wide-btn" onClick={history.goBack}>
            {this.props.t('common.labels.back')}
          </button>
        )}
        <SimpleModal
          isOpen={warningLocationOpen}
          onCancel={this.closeSelectionModal}
          onConfirm={this.onConfirmSelectionWarning}
          confirmLabel={this.props.t('common.labels.continue')}
          cancelLabel={this.props.t('common.labels.back')}
          headline={this.props.t('rosters.uncheckWarningMessage')}
        />
        <AvailableRoomsModal
          modalAvailableRoomsOpen={modalAvailableRoomsOpen}
          locationEventRoomRosters={locationEventRoomRosters}
          loadingRoomsRosters={loadingRoomsRosters}
          toggleAvailableRoomsModal={this.toggleAvailableRoomsModal}
          location={selectedLocation}
          mappedRoomTiming={this.props.mappedRoomTiming}
        />
        <AuthorizationTicketsModal
          toggleAuthorizationModal={this.toggleAuthorizationModal}
          authorizationModalOpen={this.state.authorizationModalOpen}
          id={this.props.match.params.eventId}
        />
        <MarkAsDeniedModal
          modalIsOpen={this.state.markAsDeniedModalIsOpen}
          closeModal={this.closeDeniedModal}
          numberOfSelectedExaminees={listOfSelectedExaminees.length}
          onSubmit={this.unAssignStudent}
        />
        <ModalInfo
          containerClass="mark-absent-modal-container"
          onSubmit={(e) => this.onSubmitHandle(e, true)}
          modalIsOpen={this.state.markAsAbsentModalIsOpen}
          onCancel={this.closeAbsentModal}
          className="mark-student-absent-modal"
          saveLabel={this.props.t('roomRoster.markAsAbsent')}
          cancelLabel="Cancel"
          showCancel>
          <h5>{this.props.t('roomRoster.markAsAbsentQuestion')}</h5>
          <div>
            {Parser(
              this.props.t(
                this.props.testCenterCycle.testCenterProgram?.program.parentCode === 'workkeys'
                  ? 'roomRoster.markAsAbsentTextWK'
                  : 'roomRoster.markAsAbsentText',
                {
                  number: listOfSelectedExaminees.length,
                }
              )
            )}
          </div>
        </ModalInfo>
        <AlertMessage
          show={Boolean(this.state.successAbsentMessage)}
          customMessage={this.state.successAbsentMessage}
          removeMessage={() => this.setState({ successAbsentMessage: '' })}
        />
        <AlertMessage
          show={Boolean(this.state.successDeniedMessage)}
          customMessage={this.state.successDeniedMessage}
          removeMessage={() => this.setState({ successDeniedMessage: '' })}
        />
        <AlertMessage
          show={Boolean(this.state.errorMessage)}
          message={this.state.errorMessage}
          removeMessage={() => this.setState({ errorMessage: '' })}
          isError
        />
      </div>
    );
  }
}

function mapStateToProps(state) {
  return {
    locationExamineeCount: orderLocationExamineeCount(state),
    locationEventRoomRosters: state.rosters.locationEventRoomRosters || [],
    loadingRoomsRosters: state.rosters.loadingRoomsRosters,
    locationEventExaminees: state.rosters.locationEventExaminees || [],
    loadingExaminees: state.rosters.loadingExaminees,
    examineesTotalCount: state.rosters.examineesTotalCount,
    rescheduleDates: state.rosters.locEvRescheduleDates,
    locations: state.tcEvent.eventLocations || [],
    testCenterCycle: state.tcEvent.testCenterCycle || {},
    tcEvent: state.tcEvent.currentEvent || {},
    serverDateTime: state.statics.serverDateTime,
    locEvDateFilters: mapLocEvDateFilters(state),
    evDateFilters: mapEvDateFilters(state),
    mappedRoomTiming: state.statics.mappedRoomTiming,
    personnelRoles: getPersonnelRoles(state),
    currentUser: state.users.currentUser,
    regTypes: state.statics.regTypes,
    deniedCount: state.rosters.deniedCount,
    absentCount: state.rosters.absentCount,
  };
}

function mapDispatchToProps(dispatch) {
  return {
    actions: bindActionCreators(
      {
        ...rostersActions,
        ...tcEventActions,
        ...staticActions,
      },
      dispatch
    ),
  };
}

export default withTranslation()(
  withRouterLegacy(connect(mapStateToProps, mapDispatchToProps)(RostersDashboard))
);

RostersDashboard.propTypes = {
  t: PropTypes.func.isRequired,
  locationExamineeCount: PropTypes.arrayOf(
    PropTypes.shape({
      type: PropTypes.string,
      regsCount: PropTypes.number,
    })
  ),
  locationEventRoomRosters: PropTypes.arrayOf(PropTypes.shape({})),
  loadingRoomsRosters: PropTypes.bool,
  locationEventExaminees: PropTypes.arrayOf(
    PropTypes.shape({
      id: PropTypes.number,
    })
  ),
  loadingExaminees: PropTypes.bool,
  examineesTotalCount: PropTypes.number,
  rescheduleDates: PropTypes.arrayOf(PropTypes.shape({})),
  locations: PropTypes.arrayOf(
    PropTypes.shape({
      locationEvent: PropTypes.shape({
        id: PropTypes.number,
      }),
      name: PropTypes.string,
      area: PropTypes.string,
    })
  ),
  testCenterCycle: PropTypes.shape({
    loading: PropTypes.bool,
    testCenterProgram: PropTypes.shape({
      testCenter: PropTypes.shape({
        name: PropTypes.string,
        nowManagedFlag: PropTypes.bool,
      }),
      program: PropTypes.shape({}),
    }),
    cycle: PropTypes.shape({}),
  }),
  tcEvent: PropTypes.shape({
    id: PropTypes.number,
    loading: PropTypes.bool,
    rescheduleDate: PropTypes.string,
    lastRegSyncDate: PropTypes.string,
    testingEvent: PropTypes.shape({
      name: PropTypes.string,
      adminId: PropTypes.shape({
        onlineProvider: PropTypes.string,
        cycleId: PropTypes.shape({
          id: PropTypes.number,
        }),
      }),
    }),
  }),
  serverDateTime: PropTypes.string,
  locEvDateFilters: PropTypes.arrayOf(PropTypes.shape({})),
  evDateFilters: PropTypes.arrayOf(PropTypes.shape({})),
  mappedRoomTiming: PropTypes.oneOfType([PropTypes.object, PropTypes.array]),
  personnelRoles: PropTypes.shape({}),
  currentUser: PropTypes.shape({}),
  regTypes: PropTypes.arrayOf(PropTypes.shape({})),
  deniedCount: PropTypes.number,
  absentCount: PropTypes.number,
  actions: PropTypes.shape({
    getServerDateTime: PropTypes.func,
    clearLocationEventExamineesAction: PropTypes.func,
    getTcEvent: PropTypes.func,
    getTestCenterCycle: PropTypes.func,
    getRooms: PropTypes.func,
    getEvRescheduleDates: PropTypes.func,
    getRegTypes: PropTypes.func,
    getLocEvRescheduleDates: PropTypes.func,
    getLocationEventRoomRosters: PropTypes.func,
    getLocationEventExamineeCount: PropTypes.func,
    getLocationEventExaminees: PropTypes.func,
  }),
  match: PropTypes.shape({
    params: PropTypes.shape({
      eventId: PropTypes.string,
      locationEventId: PropTypes.string,
    }),
  }),
  history: PropTypes.shape({
    goBack: PropTypes.func,
    replace: PropTypes.func,
  }),
};
